import React from 'react';

interface ProductCardProps {
  title: string;
  description: string;
  image_url: string;
  url: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  description,
  image_url,
  url,
}) => {
  return (
    <div 
      className="rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300"
      style={{ backgroundColor: 'var(--rhea-card-bg)', borderColor: 'var(--rhea-card-border)' }}
    >
      <a href={url} target="_blank" rel="noopener noreferrer" className="block">
        <div className="aspect-w-3 aspect-h-4">
          <img
            src={image_url}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-3">
          <h3 className="text-sm font-semibold mb-1" style={{ color: 'var(--rhea-text-primary)' }}>
            {title}
          </h3>
          <p className="text-xs line-clamp-2" style={{ color: 'var(--rhea-text-secondary)' }}>
            {description}
          </p>
        </div>
      </a>
    </div>
  );
};

export default ProductCard; 